import { inject, Injectable } from '@angular/core';
import { createClient, SupabaseClient } from '@supabase/supabase-js';
import { ENV } from '@hyper-inferno/hyper-base-ng';

@Injectable({
  providedIn: 'root',
})
export class SupabaseService {
  private supabase: SupabaseClient;

  environment = inject(ENV);

  constructor() {
    this.supabase = createClient(
      this.environment.supabaseUrl,
      this.environment.supabaseAnonKey,
    );
  }

  get client(): SupabaseClient {
    return this.supabase;
  }

  get storage() {
    return this.supabase.storage;
  }
}
